import { DEFAULT_TOAST_LIFE } from '../../../common/EzToast';
import {
  FETCH_CUSTOMERMARKUP_LIST_START,
  FETCH_CUSTOMERMARKUP_LIST_SUCCESS, 
  FETCH_CUSTOMERMARKUP_LIST_ERROR,
  EDIT_CUSTOMERMARKUP_RECORD,
  ADD_CUSTOMERMARKUP_RECORD,
  FUEL_COMPANY_PROVIDER_DD,
  INIT_COMPANY_MARKUP,
  FUEL_CUSTOMER_COMPANY_NAME_PROVIDER_DD
} from '../../../constants/action-types/customersMarkup';
import { customerMarkupService } from '../../../Services';
import { goBack } from '../../../utils/gotoback';
import { resetToast } from '../manage-card';

export const initializeCustomerMarkupScreen = () => ({ type: INIT_COMPANY_MARKUP });

export const customerMarkupFetchStart = (payload) => ({
  type: FETCH_CUSTOMERMARKUP_LIST_START,
  payload,
});

export const customerMarkupFetchSuccess = (payload) => ({
  type: FETCH_CUSTOMERMARKUP_LIST_SUCCESS,
  payload,
});

export const customerMarkupFetchError = (payload) => ({
  type: FETCH_CUSTOMERMARKUP_LIST_ERROR,
  payload,
});

export const fetchCustomerMarkup = (payload) => {
  return (dispatch) => {
    dispatch(customerMarkupFetchStart(payload));
    
    customerMarkupService.fetchCustomerMarkup(payload).then((customerMarkupData) => {
      if (!customerMarkupData.isError) {
        dispatch(customerMarkupFetchSuccess(customerMarkupData));
      } else {
        dispatch(customerMarkupFetchError(customerMarkupData));
      }
    });
  };
};


export const editCustomerMarkupRecordStart = (payload) => ({
  type: EDIT_CUSTOMERMARKUP_RECORD.START,
  payload
});

export const editCustomerMarkupRecordSuccess = (payload) => ({
  type: EDIT_CUSTOMERMARKUP_RECORD.SUCCESS,
  payload,
});

export const editCustomerMarkupRecordError = (payload) => ({
  type: EDIT_CUSTOMERMARKUP_RECORD.ERROR,
  payload,
});

export const editCustomerMarkup = (payload) => {
  return (dispatch) => {
    dispatch(editCustomerMarkupRecordStart());
    customerMarkupService.editCustomerMarkupRecord(payload).then((data) => {
      if (!data.isError) {
        dispatch(editCustomerMarkupRecordSuccess());
      } else {
        dispatch(editCustomerMarkupRecordError(data));
      }
      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

export const addCustomerMarkupRecordStart = (payload) => ({
  type: ADD_CUSTOMERMARKUP_RECORD.START,
  payload,
});

export const addCustomerMarkupRecordSuccess = (payload) => ({
  type: ADD_CUSTOMERMARKUP_RECORD.SUCCESS,
  payload,
});

export const addCustomerMarkupRecordError = (payload) => ({
  type: ADD_CUSTOMERMARKUP_RECORD.ERROR,
  payload,
});

export const addCustomerMarkup = (payload) => {
  return (dispatch) => {
    dispatch(addCustomerMarkupRecordStart());

    customerMarkupService.addCustomerMarkupRecord(payload).then((data) => {
      if (!data.isError) {
        dispatch(addCustomerMarkupRecordSuccess());
      } else {
        dispatch(addCustomerMarkupRecordError(data));
      }

      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};


//FUEL_COMPANY_PROVIDER_DD
export const fuelCompanyProviderStart = (payload) => ({
  type: FUEL_COMPANY_PROVIDER_DD.START,
  payload,
});

export const fuelCompanyProviderSuccess = (payload) => ({
  type: FUEL_COMPANY_PROVIDER_DD.SUCCESS,
  payload,
});

export const fuelCompanyProviderError = (payload) => ({
  type: FUEL_COMPANY_PROVIDER_DD.ERROR,
  payload,
});

export const fetchFuelCompanyProviderDD = (payload) => {
  return (dispatch) => {
    dispatch(fuelCompanyProviderStart(payload));
    
    customerMarkupService.fetchFuelCompanyProviderDD(payload).then((customerMarkupData) => {
      if (!customerMarkupData.isError) {
        dispatch(fuelCompanyProviderSuccess(customerMarkupData));
      } else {
        dispatch(fuelCompanyProviderError(customerMarkupData));
      }
    });
  };
};

export const fuelCustomerCompanyNameProviderStart = (payload) => ({
  type: FUEL_CUSTOMER_COMPANY_NAME_PROVIDER_DD.START,
  payload,
});

export const fuelCustomerCompanyNameProviderSuccess = (payload) => ({
  type: FUEL_CUSTOMER_COMPANY_NAME_PROVIDER_DD.SUCCESS,
  payload,
});

export const fuelCustomerCompanyNameProviderError = (payload) => ({
  type: FUEL_CUSTOMER_COMPANY_NAME_PROVIDER_DD.ERROR,
  payload,
});

export const fetchFuelCustomerCompanyNameProviderDD = (payload) => {
  return (dispatch) => {
    dispatch(fuelCustomerCompanyNameProviderStart(payload));
    
    customerMarkupService.fetchFuelCustomerCompanyNameProviderDD(payload).then((customerMarkupData) => {
      if (!customerMarkupData.isError) {
        dispatch(fuelCustomerCompanyNameProviderSuccess(customerMarkupData));
      } else {
        dispatch(fuelCustomerCompanyNameProviderError(customerMarkupData));
      }
    });
  };
};
